/* TU Beauty Reviews 1.0.0. No network/API calls. Source data stays in the apps. */
(function () {
  'use strict';
  const norm = value => String(value == null ? '' : value).normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim();
  const person = value => norm(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const stamp = value => {
    const text = String(value || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(text)) return '';
    if (/[+-]\d{2}:?\d{2}$/.test(text)) {
      const date = new Date(text);
      return Number.isNaN(+date) ? '' : date.toISOString().slice(0, 19);
    }
    return text.slice(0, 19);
  };
  const safeUrl = value => {
    if (!value || !String(value).trim()) return '';
    try {
      const url = new URL(String(value || ''), 'https://tubeautystore.co');
      return url.protocol === 'https:' ? url.href : '';
    } catch (_) { return ''; }
  };
  const mediaList = (items, type) => {
    if (!items) return [];
    return (Array.isArray(items) ? items : [items]).map(item => ({
      type, url: safeUrl(typeof item === 'string' ? item : item && (item.src || item.url))
    })).filter(item => item.url);
  };
  function normalizeRecord(raw, productId, source) {
    if (!raw || typeof raw !== 'object') return null;
    const customer = raw.customer || {};
    const fullName = raw.author || [customer.firstName, customer.lastName].filter(Boolean).join(' ');
    const rawProduct = String(raw.productId || (raw.product && raw.product.productId) || productId);
    const rating = Number(raw.rating == null ? raw.stars : raw.rating);
    if (!Number.isInteger(rating) || rating < 1 || rating > 5) return null;
    /* Do not silently discard published product groups, but never match their IDs to another product. */
    if (rawProduct !== String(productId) && !rawProduct.includes('-')) return null;
    const media = [].concat(mediaList(raw.images, 'image'), mediaList(raw.video, 'video'), mediaList(raw.audio, 'audio'));
    const channel = norm(raw.channel || raw.collectionChannel || '');
    return {
      source, productId: rawProduct, author: String(fullName || ''),
      displayName: String(raw.displayName || customer.firstName || fullName || 'Cliente'),
      rating, body: String(raw.body == null ? raw.comment || '' : raw.body),
      date: String(raw.date || raw.createdAt || ''),
      canonicalId: String(raw.canonicalId || ''),
      verified: raw.verified === true && Boolean(raw.verificationAuthority),
      channel: channel === 'whatsapp' || (source === 'revie' && !/judge|judgeme|email|import/.test(norm(raw.source || raw.origin || raw.importSource || ''))) ? 'whatsapp' : '', media
    };
  }
  function key(record) {
    const date = stamp(record.date), body = norm(record.body);
    if (!date || body.length < 8 || !person(record.author)) return '';
    return JSON.stringify([String(record.productId), record.rating, date, body]);
  }
  function isDuplicate(a, b) {
    if (!a || !b || a.source === b.source || String(a.productId) !== String(b.productId)) return false;
    const sharedId = a.canonicalId && a.canonicalId === b.canonicalId;
    if (!sharedId) {
      const ka = key(a);
      if (!ka || ka !== key(b)) return false;
      const an = person(a.author), bn = person(b.author);
      const exactName = an === bn;
      const shortenedName = norm(a.body).length >= 80 && an.split(' ')[0] === bn.split(' ')[0] &&
        (an === an.split(' ')[0] || bn === bn.split(' ')[0]);
      if (!exactName && !shortenedName) return false;
    }
    /* A different comment, media attachment or response must never disappear. */
    if (norm(a.body) !== norm(b.body) || a.rating !== b.rating || (a.verified && !b.verified)) return false;
    const keptMedia = new Set((b.media || []).map(item => item.url));
    return (a.media || []).every(item => keptMedia.has(item.url));
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { norm, stamp, normalizeRecord, key, isDuplicate, safeUrl };
    return;
  }
  if (window.TBReviews2027) return;
  const hubs = new Map();
  const pendingSources = [];
  const api = window.TBReviews2027 = {
    version: '1.0.0',
    registerSource(config) {
      if (!config || !config.id || !Array.isArray(config.records)) return false;
      pendingSources.push(config);
      hubs.forEach(state => { if (state.started) { addSource(state, config); schedule(state); } });
      return true;
    },
    refresh() { hubs.forEach(schedule); },
    diagnostics() { return Array.from(hubs.values()).map(state => ({
      productId: state.productId, initialized: state.started,
      nativeReviewsLoaded: state.nativeCount || 0, duplicatesSuppressed: state.duplicates || 0,
      lastProcessingMs: state.elapsed || 0
    })); }
  };
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  function badge(type) {
    const node = el('span', 'tbr-badge tbr-badge--' + type);
    const tick = el('span', '', '\u2713'); tick.setAttribute('aria-hidden', 'true');
    node.append(tick, document.createTextNode(type === 'whatsapp' ? ' WhatsApp' : ' Verificada'));
    node.title = type === 'whatsapp' ? 'Recibida por WhatsApp; el canal no acredita una compra.' : 'Verificaci\u00f3n declarada por la plataforma de origen.';
    return node;
  }
  function readJudge(state) {
    if (!state.native) return [];
    return Array.from(state.native.querySelectorAll('.jdgm-rev')).filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden').map(node => {
      const text = selector => { const n = node.querySelector(selector); return n ? n.textContent : ''; };
      const time = node.querySelector('time[datetime]');
      const rating = node.querySelector('.jdgm-rev__rating[data-score]');
      const media = Array.from(node.querySelectorAll('.jdgm-rev__pics img,.jdgm-rev__pics a[href],.jdgm-rev__vids video,.jdgm-rev__vids source')).map(m => ({
        url: safeUrl(m.getAttribute('data-src') || m.getAttribute('src') || m.getAttribute('href'))
      })).filter(m => m.url);
      const record = { source:'judge', productId:state.productId, author:text('.jdgm-rev__author'),
        body:text('.jdgm-rev__body'), date:time ? time.getAttribute('datetime') : '',
        rating:rating ? Number(rating.getAttribute('data-score')) : 0,
        canonicalId:node.getAttribute('data-review-id') || '', media,
        verified:node.getAttribute('data-verified-buyer') === 'true' };
      const author = node.querySelector('.jdgm-rev__author-wrapper');
      if (author) {
        const existing = author.querySelector('[data-tbr-verification]');
        if (record.verified && !existing) { const b = badge('verified'); b.dataset.tbrVerification = ''; author.append(b); }
        if (!record.verified && existing) existing.remove();
      }
      node.classList.toggle('tbr-native-verified', record.verified);
      return record;
    });
  }
  function formatDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (!match) return '';
    const d = new Date(Date.UTC(+match[1], +match[2]-1, +match[3]));
    return new Intl.DateTimeFormat('es-CO', {day:'numeric', month:'short', year:'numeric', timeZone:'UTC'}).format(d);
  }
  function photoDialog(url, name) {
    if (typeof HTMLDialogElement === 'undefined') { window.open(url, '_blank', 'noopener'); return; }
    const dialog = el('dialog', 'tbr-lightbox');
    const close = el('button', 'tbr-close', 'Cerrar'); close.type = 'button';
    const img = el('img'); img.src = url; img.alt = 'Foto de la rese\u00f1a de ' + name;
    dialog.append(close, img); document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => dialog.remove(), {once:true}); dialog.showModal();
  }
  function card(record) {
    const article = el('article', 'tbr-card');
    const meta = el('div', 'tbr-meta');
    const stars = el('span', 'tbr-stars', '\u2605'.repeat(record.rating) + '\u2606'.repeat(5-record.rating));
    stars.setAttribute('role','img'); stars.setAttribute('aria-label', record.rating + ' de 5 estrellas');
    meta.append(stars);
    const dateText = formatDate(record.date);
    if (dateText) { const date = el('time', 'tbr-date', dateText); date.dateTime = record.date.slice(0,10); meta.append(date); }
    const author = el('div', 'tbr-author'); author.append(el('strong', '', record.displayName));
    if (record.verified) author.append(badge('verified'));
    if (record.channel === 'whatsapp') author.append(badge('whatsapp'));
    const body = el('p', record.body ? 'tbr-body' : 'tbr-body tbr-empty-comment', record.body || 'Valoraci\u00f3n sin comentario.');
    article.append(meta, author, body);
    if (record.media.length) {
      const media = el('div', 'tbr-media');
      record.media.forEach(item => {
        if (item.type === 'image') {
          const button = el('button', 'tbr-photo'); button.type = 'button'; button.setAttribute('aria-label', 'Ampliar foto de la rese\u00f1a');
          const img = el('img'); img.src = item.url; img.alt = 'Foto de la rese\u00f1a de ' + record.displayName;
          img.loading = 'lazy'; img.decoding = 'async'; img.width = 96; img.height = 96;
          button.append(img); button.addEventListener('click', () => photoDialog(item.url, record.displayName)); media.append(button);
        } else {
          const player = el(item.type); player.controls = true; player.preload = 'none'; player.src = item.url;
          if (item.type === 'video') player.playsInline = true;
          media.append(player);
        }
      });
      article.append(media);
    }
    return article;
  }
  function addSource(state, config) {
    if (config.productId && String(config.productId) !== state.productId) return;
    let source = state.sources.get(config.id);
    if (!source) {
      const wrap = el('div', 'tbr-source tbr-source--additional');
      wrap.append(el('h3', 'tbr-source-label', config.label || 'M\u00e1s experiencias'));
      const list = el('div', 'tbr-list'), more = el('button', 'tbr-more', 'Ver m\u00e1s opiniones');
      more.type = 'button'; wrap.append(list, more); state.additional.append(wrap);
      source = {wrap,list,more,limit:8,shown:[],records:[]}; state.sources.set(config.id, source);
      more.addEventListener('click', () => { source.limit += 8; schedule(state); });
    }
    source.records = config.records.map(raw => normalizeRecord(raw, state.productId, config.id)).filter(Boolean);
    source.list.replaceChildren(); source.shown = [];
  }
  function refresh(state) {
    if (!state.hub.isConnected) { if (state.observer) state.observer.disconnect(); return; }
    if (!state.started) return;
    const start = performance.now();
    if (state.observer) state.observer.disconnect();
    try {
      const native = readJudge(state), index = new Map(), identities = new Map();
      native.forEach(record => {
        const k = key(record); if (k) { if (!index.has(k)) index.set(k, []); index.get(k).push(record); }
        if (record.canonicalId) identities.set(record.canonicalId, record);
      });
      let duplicates = 0;
      state.sources.forEach(source => {
        const visible = source.records.filter(record => {
          const candidates = record.canonicalId && identities.has(record.canonicalId) ? [identities.get(record.canonicalId)] : index.get(key(record)) || [];
          /* Only a unique candidate may suppress a cross-source duplicate. */
          const matched = candidates.filter(other => isDuplicate(record, other));
          if (matched.length === 1) { duplicates++; return false; }
          return true;
        });
        const shown = visible.slice(0, source.limit);
        const appendOnly = source.shown.length <= shown.length && source.shown.every((r, i) => r === shown[i]);
        if (!appendOnly) source.list.replaceChildren();
        const fragment = document.createDocumentFragment();
        shown.slice(appendOnly ? source.shown.length : 0).forEach(record => fragment.append(card(record)));
        source.list.append(fragment); source.shown = shown;
        source.more.hidden = shown.length >= visible.length; source.wrap.hidden = !visible.length;
        shown.forEach(record => {
          const k = key(record); if (k) { if (!index.has(k)) index.set(k, []); index.get(k).push(record); }
          if (record.canonicalId) identities.set(record.canonicalId, record);
        });
      });
      state.nativeCount = native.length; state.duplicates = duplicates;
      state.hub.classList.add('tbr-ready');
    } catch (error) {
      /* Native reviews stay visible even if an adapter fails. No app data is changed. */
      state.hub.dataset.tbrError = 'adapter';
    } finally {
      state.elapsed = Math.round((performance.now() - start) * 100) / 100;
      if (state.observer && state.native) state.observer.observe(state.native, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['data-verified-buyer','datetime','data-score','style','class','hidden']});
    }
  }
  function schedule(state) {
    if (!state.started || state.scheduled) return;
    state.scheduled = true;
    const run = () => { state.scheduled = false; refresh(state); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, {timeout:200});
    else window.requestAnimationFrame(run);
  }
  function start(state) {
    if (state.started) return;
    state.started = true;
    const data = state.hub.querySelector('[data-tbr-revie]');
    if (data) {
      try {
        let records = JSON.parse(data.textContent || '[]');
        if (typeof records === 'string') records = JSON.parse(records);
        if (!Array.isArray(records)) throw new TypeError('Review data must be an array');
        addSource(state, {id:'revie',label:'M\u00e1s experiencias',records});
      } catch (_) {
        state.additional.append(el('p', 'tbr-intro', 'No fue posible cargar algunas opiniones de otros canales. Las rese\u00f1as de la tienda siguen disponibles.'));
        state.hub.dataset.tbrError = 'source-data';
      }
    }
    pendingSources.forEach(config => addSource(state, config));
    state.observer = new MutationObserver(() => schedule(state)); refresh(state);
  }
  function setup() {
    document.querySelectorAll('[data-tbr-hub]').forEach(hub => {
      if (hubs.has(hub)) return;
      const productId = String(hub.dataset.productId || '');
      const native = Array.from(document.querySelectorAll('.jdgm-widget.jdgm-review-widget')).find(node =>
        node.getAttribute('data-id') === productId && !node.closest('.screen-layer,.modal,#QuickShopModal'));
      const state = {hub,productId,native,additional:hub.querySelector('[data-tbr-additional]'),sources:new Map(),started:false,scheduled:false};
      hubs.set(hub,state);
      if (native) {
        native.before(hub); hub.querySelector('[data-tbr-judge]').append(native);
      } else {
        const anchor = document.querySelector('#MainContent .product-section') || document.querySelector('#MainContent');
        if (anchor) anchor.after(hub);
        hub.querySelector('[data-tbr-judge-source]').hidden = true;
      }
      const oldAnchor = hub.querySelector('#content-rl-w');
      const deepLink = ['#tb-reviews-unified','#content-rl-w','#judgeme_product_reviews'].includes(location.hash) || new URLSearchParams(location.search).has('gotorevieList');
      if ('IntersectionObserver' in window && !deepLink) {
        const gate = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { gate.disconnect(); start(state); } }, {rootMargin:'600px 0px'});
        gate.observe(hub);
      } else {
        start(state);
        if (deepLink) requestAnimationFrame(() => (oldAnchor || hub).scrollIntoView({block:'start'}));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
